import {getProviderByNpi} from "../api/getters/provider";
import types from './types';
import kinds from '@/constants/kinds';
import _ from 'lodash';
/**
 * Sorts given array by date (reversed chronological order)
 */
const sort = (arr) => {
  return _.orderBy(arr, [( element ) => { return element.lo || element.lodate || '' }], 'desc');
};

export const getPhoneTypes = (allData) => allData.phoneTypes;
export const getStates = (allData) => allData.states;
export const getRels = (allData) => allData.relationDescriptions

export const getFormattedMeters = (allData) => {
  let results = {}
  let m = allData.meters
  if (m && m.length != 0) {
    m.forEach(meter => {
      results[meter.id] = meter.items
    })
  }
  return results
}

export const getFormattedRelationsList = (allData) => {
  let results = [];
  let headIndex = -100;
  let relation;
  let relations = getRelations(allData);
  for(relation in relations) {
    let _relation = relations[relation];
    results = [...results,{
      description:_relation.description,heading:true,id:headIndex--
    }];
    let value;
    let sorted = [..._relation.value];
    sorted.sort((a,b) => {
      if(a.lastName<b.lastName)
        return -1;
      else if(a.lastName>b.lastName)
        return 1;
      else if(a.firstName<b.firstName)
        return -1;
      else if(a.firstName>b.firstName)
        return 1;
      else return 0;
    });
    for(value in sorted) {
      let _value = sorted[value];
      results = [...results,{
        ..._value,
        heading: false,
        description: `${_value.lastName},${_value.firstName} ${_value.dob}`
      }];
    }
  }
  return results;
};

export const getAdministrator = (allData) => {
  return allData.administrator ? true : false;
};
export const getImpersonation = (allData) => {
  return allData.impersonation;
};
export const getInvited = (allData) => {
    return allData.invited || false;
};
export const getRelations = (allData) => {
  return allData.patient.relations;
};
export const getDescByCcd = (ccd, allData) => {
  if (ccd == 21334) return 'Wt'
  if (ccd == 23553) return 'Wt meas'
  if (ccd == 32077) return 'BMI'
  if (ccd == 34204) return 'Gluc'
  if (ccd == 54069 || ccd == 54350) return 'SpO2'
  if (ccd == 76633) return 'DBP'
  if (ccd == 77222) return 'Ht'
  if (ccd == 77229) return 'Temp'
  if (ccd == 77371) return 'SBP'
  if (ccd == 77808) return 'HR'
  return allData.ccds[ccd] ? allData.ccds[ccd].desc : '';
};
export const getCodeByCcd = (ccd, allData) => {
  return allData.ccds[ccd] ? allData.ccds[ccd].code : '';
};
export const getMeasIdsByProcId = (id, allData) => {
  return allData.procmeas[id];
};
export const getMeasDescById = (id, allData) => {
  return allData.ccds[allData.measures[id].codes[0]].desc;
};
export const getProcDescById = (id, allData) => {
  return allData.ccds[allData.procedures[id].codes[0]].desc;
};
export const getDiagDescById = (id, allData) => {
  return allData.ccds[allData.diagnosiss[id].codes[0]].desc;
};
export const getMedicationDescById = (id, allData) => {
  return allData.ccds[allData.medications[id].codes[0]].desc;
};
export const getAllergyDescById = (id, allData) => {
  return allData.ccds[allData.allergies[id].codes[0]].desc;
};
export const getVaccineDescById = (id, allData) => {
  return allData.ccds[allData.vaccines[id].codes[0]].desc;
};
export const getReportDescById = (id, allData) => {
  let category = allData.reports[id].category;
  return (typeof category !== 'undefined' && category)
  ? allData.ccds[category].desc
  : 'Report';
};
export const getAllProcedures = (allData) => {
  const proceduresModel = allData.procedures;
  let procedures = [];

  Object.keys(proceduresModel).forEach((key, index) => {
    let proc = proceduresModel[key];
    procedures[index] = {
      'id': key,
      'lodate': proc.lodate,
      'ccd': proc.ccd,
      'npi': proc.npi,
      'desc': getDescByCcd(proc.ccd),
      'measures': getAllMeasByProcId(proc.id),
    }
  });

  return sort(procedures);
};

export const getAllReports = (allData) => {
  let reports = [];
  
  const allReports = allData.reports;  
  for(let id in allReports)
   {
    let report = allReports[id];
    let newReport = JSON.parse(JSON.stringify(report));
    let codes = [];
    newReport.cdas = [];
    newReport.description = '';
    if(newReport.category) {
      codes.unshift(newReport.category);
      newReport.category = allData.ccds[newReport.category].desc;
    }
    if(newReport.procCcd) {
      codes.unshift(newReport.procCcd);
      newReport.procCcd = allData.ccds[newReport.procCcd].desc;
    }
    newReport.codes = codes;
    reports.push(newReport);
  }
  return reports;
}

export const getAllProviders = (allData) => {
  let taxonomies = [];
  const allTaxonomies = allData.taxonomies;
  for(let id in allTaxonomies)
  {
    let taxonomy = allTaxonomies[id];
    let newTaxo = {
      description: taxonomy.specialOrClassName,
      codes : [taxonomy.id],
      cdas : [],
      npis : taxonomy.npis
    }
    let taxo = JSON.parse(JSON.stringify(newTaxo));
    taxonomies.unshift(taxo);
  }
  return _.orderBy(taxonomies, [( element ) => { return element.description || '' }]);
};

/**
 * returns all procedures (object of id, cdd, date) - for procedure page
 */
export const getAllProcedures_no_meas = (allData) => {
  let procedures = [];
  let keys = Object.keys(allData.procedures);
  let i = 0;
  for (i; i < keys.length; i++) {
    let procedure = JSON.parse(JSON.stringify(allData.procedures[keys[i]]));
    procedures.push({
      id: procedure.id,
      ccd: procedure.ccd,
      npi: procedure.npi,
      lodate: procedure.lodate,
      isFromReport: false,
      cda: getCdaIndexById(allData, procedure.cda)
    });
  }
  // also get procedures from reports
  for (let j = 0; j < allData.reports.length; j++) {
    let report = JSON.parse(JSON.stringify(allData.reports[j]));

    // FIXEDME?: this is not working
    // if procedure exists
    if (typeof report.procCcd === 'undefined' || report.procCcd === null)
      continue;
    procedures.push({
      id: `report_${report.id}`,     // not to conflict with procedure.id
      reportId: report.id,
      reportIndex: j,
      ccd: report.procCcd,
      lodate: report.when,
      isFromReport: true});
  }
  return sort(procedures);
};

export const getAllMeasByProcId = (procId, allData) => {
  const allMeasures = allData.measures;
  const measIds = getMeasIdsByProcId(procId, allData);

  if (!measIds)
    return [];

  let measures = [];
  let measureDetail;

  if (measIds !== null) {

    // find measure detail from the measures model
    measIds.forEach((measId, index) => {
      measureDetail = allMeasures[measId];

      // construct measures
      measures.push({
        'id': measId,
        'value': measureDetail.value,
        'units': measureDetail.units,
        'lodate': measureDetail.lodate,
        'ccd': measureDetail.ccd,
        'weight': measureDetail.weight,
        'desc': getDescByCcd(measureDetail.ccd, allData), // TODO: to title case?
      });
    });
  }

  // return _.orderBy(measures, [( element ) => { return element.weight || 0 }], 'asc');

  return measures;
};

export const isOfficeVisit = (proc,allData) => {
   return proc.ccd && allData.ccds[proc.ccd].officevisit;
};

export const hasMeasures = (procId, allData, cdaIndex = null) => {
  const procmeas = (cdaIndex === null) ? allData.procmeas : allData.cdas[cdaIndex].eprocmeas;
  return typeof procmeas[procId] !== 'undefined' && procmeas[procId].length > 0;
};

export const getAllProcuedures = (allData) => {
  let procedures = [];
  const allDiagnoses = allData.diagnosisGroupings;
  for (let id in allDiagnoses) {
    let proc = JSON.parse(JSON.stringify(allDiagnoses[id]));
    procedures.unshift(proc);
  }
  return sort(procedures);
};

export const getAllDiagnosis = (allData) => {
  let diagnoses = [];
  const allDiagnoses = allData.diagnosisGroupings;
  for (let id in allDiagnoses) {
    let diag = JSON.parse(JSON.stringify(allDiagnoses[id]));
    diagnoses.unshift(diag);
  }
  
  return sort(diagnoses);
};

export const getCdaTitleByDiagnosisId = (allData, diagnosisId) => {
  const cdas = allData.cdas;
  for (let index in cdas) {
    if (cdas[index].diagnosiss.hasOwnProperty(diagnosisId)) {
      return cdas[index].recordedAt;
    }
  }
};
//
// export const getProviderInfoByNpi = (npi, allData) => {
//   if (typeof(npi) === 'undefined')
//     return null;
//
//   const providerInfo = allData.npis[npi];
//   if (typeof(providerInfo) !== 'undefined' && providerInfo) {
//     const bioTypes = ['pr', 'ot', 'ao'];
//     for (let i = 0; i < bioTypes.length; i++) {
//       const bio = providerInfo[bioTypes[i]];
//       if (bio !== null && typeof(bio) !== "undefined") {
//         return {
//           firstname: bio.fst,
//           lastname: bio.lst
//           //TODO: add mroe info
//         }
//       }
//     }
//   }
//   return null;
// };

export const getAllProcedures0 = (allData) => {
  let procedures  = [];
  const allProcedures = allData.procedureGroupings ;
  //for (let idp in allProcedures) {
  for (let idp = 0;idp < allProcedures.length;idp++) {
    let newRecord = { ...allProcedures[idp], measures: {} };
    for(let idm in newRecord.ids) {
      newRecord.measures[idm] = getAllMeasByProcId(idp,allData);
    }
    let procedure = JSON.parse(JSON.stringify(/*allProcedures[id]*/newRecord));
    // console.log(procedure)
    procedures.unshift({
      ...procedure
    });
  }
  // console.log(procedures)
  return procedures;
};

export const getAllProcedureKinds = (allData) => {
  let procedureKinds = []
  const allProcedures = allData.procedureGroupings
  const allProcedureKinds = allData.procedureKindGroupings
  for (let idk = 0; idk < allProcedureKinds.length; idk++){
    let codeVal = allProcedures[allProcedureKinds[idk].position[0]].codes[0]
    let procName = allData.ccds[codeVal].desc
    let newKind = { procName, procedures: [] }
    for (let idp in allProcedureKinds[idk].position){
      let newRecord = { ...allProcedures[allProcedureKinds[idk].position[idp]], measures: {} }
      for (let idm in newRecord.ids) {
        newRecord.measures[idm] = getAllMeasByProcId(idp, allData)
      }
      let procedure = JSON.parse(JSON.stringify(newRecord))
      newKind.procedures.unshift({
        ...procedure
      })
    }
    procedureKinds.push(newKind)
  }
  // console.log(procedureKinds)
  return procedureKinds
}

export const getAllMedications = (allData) => {
  let medications = [];
  const allMedications = allData.medicineGroupings;
  for (let id in allMedications) {
    let med = JSON.parse(JSON.stringify(allMedications[id]));
    let provider = med.npi ? getProviderByNpi(allData, med.npi) : null;
    medications.push({
      ...med,
      provider
    });
  }
  return medications;
};

export const getPrimaryContact = (contacts) => {
  return _.find(contacts,['primaryContact',true]);
};
/**
 *
 * @param itemsArray an array of model elements
 * @returns an array of objects grouped by code
 *    [
 *      { code1: [ {object detail}, {object detail} ] },
 *      { code2: [ {object detail}, {object detail} ] },
 *    ]
 */
// 257 items
export const groupItemsByCode = (itemsArray) => {
  // store to an object first, easier to find out if a code already exists or not
  let groupedItems = {};
  itemsArray.forEach(item => {
    // set code as the property key, an array of items (with the same code) as the value
    (groupedItems[item.codes[0]] || (groupedItems[item.codes[0]] = [])).unshift(item);
  });

  // convert the object of objects to an array of objects
  let arr = [];
  Object.keys(groupedItems).forEach(itemKey => {
    arr.unshift({
      [itemKey]: groupedItems[itemKey]
    });
  });

  return arr;
};

export const getPdfIndexById = (allData, pdfId ) => {
  const pdfs = allData.pdfs;
  let indexFound = -1;
  if(pdfs) {
    for (let index=0; index<pdfs.length; index++) {
      if (pdfs[index].id === pdfId)
      indexFound = index;
    }
  }
  return indexFound;
};

export const getReportIndexById = (allData, reportId) => {
  const reports = allData.reports;
  let indexFound = -1;
  for (let index=0; index<reports.length; index++) {
    if (reports[index].id === reportId)
    indexFound = index;
  }
  return indexFound;
};

export const getCdaIndexById = (allData, cdaId) => {
  const cdas = allData.cdas;
  let indexFound = -1;
  for (let index=0; index<cdas.length; index++) {
    if (cdas[index].id === cdaId)
    indexFound = index;
  }
  return indexFound;
};

export const getAllVaccinations = (allData) => {
  let vaccinations = [];
  const allVaccines = allData.vaccineGroupings;
  for (let i in allVaccines) {
    // let vac = JSON.parse(JSON.stringify(allData.vaccines[id]));
   // vac.cda = getCdaIndexById(allData, vac.cda),
    let vac = JSON.parse(JSON.stringify(allVaccines[i]));
    vaccinations.unshift(vac);
  }
  return vaccinations;
};

export const getAllAllergies = (allData) => {
  let allergies = [];
//  const allAllergies = allData.allergies;
  const allAllergies = allData.allergyGroupings;
  for (let id in allAllergies) {
    let allergy = JSON.parse(JSON.stringify(allAllergies[id]));
//    allergy.cda = getCdaIndexById(allData, allergy.cda),
    allergies.unshift(allergy);
  }

  // remove duplicates by substance name
  // let allergiesWithoutDuplicates = allergies.filter((obj, pos, arr) => {
  //   return arr.map(mapObj => mapObj['substance']).indexOf(obj['substance']) === pos;
  // });

  return sort(allergies);
};

export const getRawItemsByType = (type,allData) => 
  type === types.vaccination ? allData.vaccines :
  type === types.diagnosis ? allData.diagnosiss :
  type === types.allergy ? allData.allergies :
  type === types.medication ? allData.medications :
  type === types.reports ? allData.reports :
  type === types.directives ? allData.reports :
  type === types.procedure ? allData.procedures : null

export const getItemsByType = (type, allData) => {
  let items = null;
  switch (type) {
    case types.reports:
    case types.directives:
      items = getAllReports(allData);
      break;
    case types.providers:
      items = getAllProviders(allData);
      break;
    case types.allergy:
      items = getAllAllergies(allData);
      break;
    case types.procedures:
//      return getAllProcedures_no_meas(allData);   // TODO temp solution, need to group procedures as well
      items = getAllProcedures0(allData);
      break
    case types.procedureKinds:
      items = getAllProcedureKinds(allData)
      break;
    case types.diagnosis:
      items = getAllDiagnosis(allData);
      break;
    case types.medication:
      items = getAllMedications(allData);
      break;
    case types.vaccination:
      items = getAllVaccinations(allData);
      break;
    default:
      break;
  }
  // console.log(allData)
  return (
    type === types.vaccination ||
    type === types.diagnosis ||
    type === types.allergy ||
    type === types.medication || 
    type === types.procedures ||
    type === types.procedureKinds ||
    type === types.reports || 
    type === types.providers ||
    type === types.directives
    ) ? items : groupItemsByCode(items);
};

export const getMeasureWeightByCcd = (ccd, allData) => {
  const measures = allData.measures;

  //FIXME: ??? linear traversal to get measure?
  for (let key in measures) {
    // need type coercion
    if (measures.hasOwnProperty(key) && measures[key].ccd == ccd) {
      return measures[key].weight ? measures[key].weight : 0;
    }
  }

  return 0;
};

export const getMeasureUnitByCcd = (ccd, allData) => {
  const measures = allData.measures;

  for (let key in measures) {
    if (measures.hasOwnProperty(key) && measures[key].ccd == ccd) {
      return measures[key].units;
    }
  }
};

export const getDescByKindAndId = (kind, id, allData) => {
  let desc = null;
  if (kind === kinds.E_PROCEDURE || kind === kinds.PROCEDURE) {
    desc = getProcDescById(id,allData);
  } else if (kind === kinds.E_MEASURE || kind === kinds.MEASURE) {
    desc = getMeasDescById(id,allData);
  } else if (kind === kinds.E_DIAGNOSIS || kind === kinds.DIAGNOSIS) {
    desc = getDiagDescById(id,allData);
  } else if (kind === kinds.E_MEDICATION || kind === kinds.MEDICATION) {
    desc = getMedicationDescById(id,allData);
  } else if (kind === kinds.E_VACCINE || kind === kinds.VACCINE) {
    desc = getVaccineDescById(id,allData);
  } else if (kind === kinds.E_ALLERGY || kind === kinds.ALLERGY) {
    desc = getAllergyDescById(id,allData);
  } else if (kind === kinds.REPORT) {
    desc = getReportDescById(id,allData);
  } 
  return desc;
};

export const getHeaderByKind = (kind, x="", y="") => {
  if (kind === kinds.E_PROCEDURE || kind === kinds.PROCEDURE) {
    return 'Procedures';    
  } else if (kind === kinds.E_MEASURE || kind === kinds.MEASURE) {
    return 'Vitals';
  } else if (kind === kinds.E_DIAGNOSIS || kind === kinds.DIAGNOSIS) {
    return 'Diagnoses';
  } else if (kind === kinds.E_MEDICATION || kind === kinds.MEDICATION) {
    return 'Medications';
  } else if (kind === kinds.E_VACCINE || kind === kinds.VACCINE) {
    return 'Vaccines';
  } else if (kind === kinds.E_ALLERGY || kind === kinds.ALLERGY) {
    return 'Allergies';
  } else if (kind === kinds.E_OTHER || kind === kinds.OTHER) {
    return 'Other'
  } else if (kind === kinds.REPORT) {
    return 'Reports';
  } else {
    return kind;
  }
};

export const getCondensedDatesForGridLimited = (allData, measCcds, limit, sortBy=(a,b)=>new Date(b)-new Date(a)) => {
  const measures = allData.measures;
  const measCcdMeasIds = allData.measCcdMeasIds;
  let dates = {};
  let date;
  let measIds;
  let _limit = limit.valueOf();
  for (let measCcd of measCcds) {
    measIds = measCcdMeasIds[measCcd]
    for (let measId of measIds) {
      date = measures[measId].lotimestamp;
      if (!dates[date] && Date.parse(date).valueOf() >= _limit)
        dates[date] = true;
    }
  }
  
  let datesUnsorted = Object.keys(dates);
  return datesUnsorted.sort(sortBy);
}

export const getCondensedDatesForGrid = (allData, measCcds, sortBy=(a,b)=>new Date(b)-new Date(a)) => {
  const measures = allData.measures;
  const measCcdMeasIds = allData.measCcdMeasIds;
  let dates = {};
  let date;
  let measIds;
  for (let measCcd of measCcds) {
    measIds = measCcdMeasIds[measCcd]
    for (let measId of measIds) {
      date = measures[measId].lotimestamp;
      if (!dates[date])
        dates[date] = true;
    }
  }
  
  let datesUnsorted = Object.keys(dates);
  return datesUnsorted.sort(sortBy);
}

/**
 * Returns dictionary with meas ccd as key, and all instances of ccd as value with corresponding date as key
 * @param {Object} allData 
 * @param Array} measCcds 
 */
export const getMeasCcdDateMatrixLimited = (allData, measCcds,limit) => {
  const measCcdMeasIds = allData.measCcdMeasIds;
  let measCcdDateMatrix = {};
  let measIds;
  let measure;
  let date;
  let limitTime = limit.getTime();
  for(let measCcd of measCcds) {
    measIds = measCcdMeasIds[measCcd];
    measCcdDateMatrix[measCcd] = {};

    for (let measId of measIds) {
      measure = allData.measures[measId];
      date = measure.lotimestamp;
      if(Date.parse(date).valueOf() >= limitTime)
      {
        measCcdDateMatrix[measCcd][date] = measure;
      }
    }
  }
  return measCcdDateMatrix;
}

export const getMeasCcdDateMatrix = (allData, measCcds) => {
  const measCcdMeasIds = allData.measCcdMeasIds;
  let measCcdDateMatrix = {};
  let measIds;
  let measure;
  let date;
  for(let measCcd of measCcds) {
    measIds = measCcdMeasIds[measCcd];
    measCcdDateMatrix[measCcd] = {};

    for (let measId of measIds) {
      measure = allData.measures[measId];
      date = measure.lotimestamp;
      measCcdDateMatrix[measCcd][date] = measure;
    }
  }
  return measCcdDateMatrix;
}

export const getMeasAndDateGrid = (allData, measCcds) => {
  const measCcdDateMatrix = getMeasCcdDateMatrix(allData, measCcds);
  const dates = getCondensedDatesForGrid(allData, measCcds);
  let measAndDateGrid = [];
  let columns;
  // row
  for (let measCcd in measCcdDateMatrix) {
    // date columns 
    columns = {};
    for (let date of dates) {
      columns[date] = measCcdDateMatrix[measCcd][date];
    }
    measAndDateGrid.push({ccd: measCcd, dateEntries: columns});
  }
  return measAndDateGrid;
}

export const getMeasAndDateGridLimited = (allData, measCcds, limit) => {
  const measCcdDateMatrix = getMeasCcdDateMatrixLimited(allData, measCcds, limit);
  const dates = getCondensedDatesForGridLimited(allData, measCcds, limit);
  let measAndDateGrid = [];
  let columns;
  // row
  for (let measCcd in measCcdDateMatrix) {
    // date columns 
    columns = {};
    for (let date of dates) {
      columns[date] = measCcdDateMatrix[measCcd][date];
    }
    measAndDateGrid.push({ccd: measCcd, dateEntries: columns});
  }
  return measAndDateGrid;
}
